const typeOfQuestion = {
  simple: 4,
  multiple: 5,
  open: 7,
  escalar_text: 12,
  escalar_numeric: 6,
};
export default typeOfQuestion;
